//dependency import ==>
import React from "react";
//css and asset import ==>
import "./prePrintedStationary.scss";
import { RX_PROPERTIES } from "../constant";

const PrePrintStationaryDisplay = (props) => {
  //const ==>
  const {
    customMarginVal,
    prePrintedStationaryTitle,
    handleMarginChange,
    PmrActClsName,
    setPrintMarginUnit,
    setCustomMarginVal,
    printMarginUnit,
    titleUnit1,
    titleUnit2,
    subtitle,
    selectTitle,
  } = props;
  //<==

  //Action ==>
  const handleMarginUpdate = (marginUnit) => {
    setPrintMarginUnit(marginUnit);
    setCustomMarginVal({
      ...RX_PROPERTIES,
    });
  };

  //<==
  //create UI ==>

  const createSelectUnitUI = () => {
    return (
      <div>
        <p className="prefill-fontsize ">{selectTitle}</p>
        <div className="d-flex">
          <div
            className="PPS-cm-div prefill-unit hover-pointer"
            onClick={() => handleMarginUpdate("cm")}
          >
            <label
              className="pre-Staionary-checkBox hover-pointer"
              style={
                printMarginUnit == "cm" ? { backgroundColor: "#17bae0" } : null
              }
            >
              <span>
                {printMarginUnit == "cm" ? (
                  <i className="fa fa-check facheck"></i>
                ) : null}
              </span>
            </label>
            {titleUnit1}
          </div>

          <div
            className="PPS-inch-div prefill-onclick hover-pointer"
            onClick={() => handleMarginUpdate("in")}
          >
            <label
              className="pre-Staionary-checkBox hover-pointer"
              style={
                printMarginUnit == "in" ? { backgroundColor: "#17bae0" } : null
              }
            >
              <span>
                {printMarginUnit == "in" ? (
                  <i className="fa fa-check facheck"></i>
                ) : null}
              </span>
            </label>
            {titleUnit2}
          </div>
        </div>
      </div>
    );
  };

  const createPrescriptionMarginUI = () => {
    return (
      <div className="PPS-custom-mr-div">
        <div className="PPS-prescription-mr-div">
          <div className="prescription-title">Prescription Margin</div>
          <h6 className="prefill-fontsize ">{prePrintedStationaryTitle}</h6>
          <div className="prefilled-margin-main cus-mr-inp-bg">
            <input
              type="number"
              name="rxTop"
              className="cus-mr-width"
              value={customMarginVal.rxTop >= 0 ? customMarginVal.rxTop : ""}
              onChange={handleMarginChange}
              placeholder="|"
            />
            <span className="prefill-fontsize ">{printMarginUnit}</span>
          </div>
          <div className="prefill-display">
            <div className="prefill-handel-margin-view cus-mr-inp-bg rounded">
              <input
                type="number"
                name="rxLeft"
                className="cus-mr-width"
                value={
                  customMarginVal.rxLeft >= 0 ? customMarginVal.rxLeft : ""
                }
                onChange={handleMarginChange}
                placeholder="|"
              />
              <span className="prefill-fontsize ">{printMarginUnit}</span>
            </div>
            <div className={`custom-mr-div m-3 ${PmrActClsName} `}>
              {subtitle}
            </div>
            <div className=" prefill-handel-margin-view cus-mr-inp-bg rounded">
              <input
                type="number"
                name="rxRight"
                className="cus-mr-width"
                value={
                  customMarginVal.rxRight >= 0 ? customMarginVal.rxRight : ""
                }
                onChange={handleMarginChange}
                placeholder="|"
              />
              <span className="prefill-fontsize ">{printMarginUnit}</span>
            </div>
          </div>
          <div className="prefill-handel-margin-view cus-mr-inp-bg rounded">
            <input
              type="number"
              name="rxBottom"
              className="cus-mr-width"
              value={
                customMarginVal.rxBottom >= 0 ? customMarginVal.rxBottom : ""
              }
              onChange={handleMarginChange}
              placeholder="|"
            />
            <span className="prefill-fontsize ">{printMarginUnit}</span>
          </div>
        </div>
      </div>
    );
  };

  //<==
  return (
    <div className="admin-pre-printed-stationary">
      <div className="admin-Pre-Printed-staionary-main ">
        <hr className="admin-pre-Staionary-div-hr" />
        {createSelectUnitUI()}
        {createPrescriptionMarginUI()}
      </div>
    </div>
  );
};

export default PrePrintStationaryDisplay;
